import { ENavigationStatus } from 'core/model/enums/navigation.enum';
import { TPriceGroupForAutocomplete } from 'core/model/interfaces/master-entities';
import type {
  INavigationTreeDetail,
  INavigationTreeList,
  TNavigationTreeDetailCreateForm,
  TNavigationTreeDetailEditForm,
} from 'core/model/interfaces/navigation';
import type {
  IGetNavigationPriceGroupsResponse,
  IGetNavigationTreeListResponse,
  INavigationTreeListItemResponse,
} from './navigation.dto';

export const getNavigationTreeStatus = (isPublished: boolean, isCompleted: boolean, isEmpty: boolean): number => {
  if (isPublished) return ENavigationStatus.PUBLISHED;
  if (isCompleted) return ENavigationStatus.PENDING_PUBLICATION;
  if (isEmpty) return ENavigationStatus.EMPTY;
  return ENavigationStatus.INCOMPLETE_EDITION;
};

export const toINavigationTreeItems = (response: IGetNavigationTreeListResponse): INavigationTreeList => ({
  pagination: response.pagination,
  trees: response.navigations.map(tree => ({
    name: tree.name,
    treeId: tree.id,
    status: getNavigationTreeStatus(tree.isPublished, tree.isCompleted, tree.isEmpty),
    default: tree.isDefault,
  })),
});

export const toINavigationTreeDetail = (response: INavigationTreeListItemResponse): INavigationTreeDetail => {
  const { navigation } = response;
  return {
    name: navigation.name,
    id: navigation.id,
    default: navigation.isDefault,
    priceListIds: navigation.priceGroups?.flatMap(group => group.priceListIds?.map(list => `${list}`) || []) || [],
    priceGroupIds: navigation.priceGroups?.map(group => group.id) || [],
    familyOrderFile: {
      url: navigation.orderedFamiliesFilePath,
    },
  };
};

export const priceGroupsDTO = (response: IGetNavigationPriceGroupsResponse): Array<TPriceGroupForAutocomplete> => {
  const result: Array<TPriceGroupForAutocomplete> = response.priceGroups.map(priceGroup => ({
    value: priceGroup.externalId,
    label: priceGroup.name,
    options:
      priceGroup.priceLists.map(priceList => ({
        value: priceList.id,
        label: priceList.name,
      })) || [],
  }));
  return result;
};

export const toFormDataFromNavigationTreeForm = (
  data: TNavigationTreeDetailCreateForm | TNavigationTreeDetailEditForm,
  navigationId?: number,
): FormData => {
  const formData = new FormData();
  if (data.familyOrderFile && data.familyOrderFile.blob) {
    formData.append('orderedFamilies', data.familyOrderFile.blob);
  }
  formData.append('name', data.name);
  data.priceListIds.forEach(priceList => formData.append('priceListIds[]', priceList));
  if (navigationId) formData.append('navigationId', `${navigationId}`);

  return formData;
};
